import axiosInstance from "./axiosInstance";

export const demoBuyStock = async ({ symbol, quantity, price }) => {
  const { data } = await axiosInstance.post("/demo-user/buy-stock/", {
    symbol,
    quantity,
    price,
  });

  return data;
};

export const demoSellStock = async ({ symbol, quantity, price }) => {
  const { data } = await axiosInstance.post("/demo-user/sell-stock/", {
    symbol,
    quantity,
    price,
  });

  return data;
};

export const demoUserStock = async () => {
  const { data } = await axiosInstance.post("/demo-user/sell-stock/", {});

  return data;
};

export const demoUserHolding = async () => {
  const { data } = await axiosInstance.get("/demo-user/holdings", {});
  console.log("Holdings Data:", data);

  return data.data;
};

export const demoUserDetails = async () => {
  const { data } = await axiosInstance.get("/demo-user/user", {});
  console.log("User Details:", data);

  return data;
};

export const resetFunds = async () => {
  const { data } = await axiosInstance.post("/demo-user/reset-funds", {});
  console.log("Reset Funds Data:", data);

  return data;
};
  